document.addEventListener('DOMContentLoaded', (event) => {
  document.addEventListener('click',(e) => {
    if(e.target && e.target.classList.contains('overflow--scroll-x__arrow')) {
      e.preventDefault();
      const t = e.target;
      const slider = t.closest('.collection').querySelector('.overflow--scroll-x');
      const itemWidth = (slider.querySelector('.overflow--scroll-x__item').offsetWidth * 2) + 20;
      const scrollPosition = e.target.classList.contains('overflow--scroll-x__next') ? itemWidth + slider.scrollLeft : slider.scrollLeft - itemWidth;
      slider.scrollTo({
        top: 0,
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  });
});